import type { ReactNode } from 'react'

type BadgeVariant = 'success' | 'danger' | 'warning' | 'primary' | 'gray'

type BadgeProps = {
  variant?: BadgeVariant
  children: ReactNode
  className?: string
}

const variantClasses: Record<BadgeVariant, string> = {
  success: 'badge-success',
  danger: 'badge-danger',
  warning: 'badge-warning',
  primary: 'badge-primary',
  gray: 'badge-gray',
}

export function Badge({
  variant = 'gray',
  children,
  className = '',
}: BadgeProps) {
  return (
    <span className={`badge ${variantClasses[variant]} ${className}`}>
      {children}
    </span>
  )
}

type ConfidenceBadgeProps = {
  score: number
}

export function ConfidenceBadge({ score }: ConfidenceBadgeProps) {
  let variant: BadgeVariant = 'gray'

  if (score >= 70) {
    variant = 'danger'
  } else if (score >= 40) {
    variant = 'warning'
  } else {
    variant = 'success'
  }

  return <Badge variant={variant}>{score}%</Badge>
}

type StatusBadgeProps = {
  isActive: boolean
}

export function StatusBadge({ isActive }: StatusBadgeProps) {
  return (
    <Badge variant={isActive ? 'success' : 'gray'}>
      {isActive ? 'Active' : 'Inactive'}
    </Badge>
  )
}

type AlertStatusBadgeProps = {
  status: 'sent' | 'failed' | 'pending'
}

export function AlertStatusBadge({ status }: AlertStatusBadgeProps) {
  const variants: Record<string, BadgeVariant> = {
    sent: 'success',
    failed: 'danger',
    pending: 'warning',
  }

  return <Badge variant={variants[status]}>{status}</Badge>
}
